export const SET_ALERT = 'SET_ALERT';
export const SET_SIDEBAR = 'SET_SIDEBAR';
export const SET_PAGE_TITLE = 'SET_PAGE_TITLE';
export const SET_LANGUAGE = 'SET_LANGUAGE';